import { useCallback } from 'react';
import axios from 'axios';
import { ACTIONTYPE, LivekitStatus, LivekitQualityStatus } from '../AppStateProvider';
import ConnectionCheck from '../../../container/livekitConnection/connectionHelper/connectionChecker';
import { LIVEKIT_CLOUD } from '../../../constants';

export default function useLivekitTest(provider: string, dispatch: React.Dispatch<ACTIONTYPE>) {
  const startLivekitTest = useCallback(() => {
    const statusObj: LivekitStatus = {};
    const qualityObj: LivekitQualityStatus = {};
    return axios
      .post('app/livekit-token', { params: provider })
      .then(async (response) => {
        const isLivekitCloud = provider === LIVEKIT_CLOUD;

        const url = isLivekitCloud
          ? process.env.REACT_APP_LIVEKIT_CLOUD_URL
          : process.env.REACT_APP_LIVEKIT_SELF_HOSTED_URL;
        const conn = new ConnectionCheck(url || '', response?.data?.token);
        const ws = await conn.checkWebsocket();
        statusObj['Signal Connection'] = ws?.status;
        const webRtcInfo = await conn.checkWebRTC();
        statusObj['Webrtc Connection'] = webRtcInfo?.status;
        const turn = await conn.checkTURN();
        statusObj['Turn'] = turn?.status;
        const audio = await conn.checkPublishAudio();
        statusObj['Publish Audio'] = audio?.status;
        const video = await conn.checkPublishVideo();
        statusObj['Publish Video'] = video?.status;
        const reconnect = await conn.checkReconnect();
        statusObj['Reconnection'] = reconnect?.status;

        qualityObj['audio'] = {
          jitter: Number(audio?.logs?.[1]?.message),
          packetLoss: Number(audio?.logs?.[2]?.message),
          RTT: JSON.parse(audio?.logs?.[3]?.message),
          bitrate: JSON.parse(audio?.logs?.[4]?.message),
        };
        qualityObj['video'] = {
          jitter: Number(video?.logs?.[1]?.message),
          packetLoss: Number(video?.logs?.[2]?.message),
          RTT: JSON.parse(video?.logs?.[3]?.message),
          bitrate: JSON.parse(video?.logs?.[4]?.message),
        };

        dispatch({ type: 'livekit-connectivity-test', statusObj });
        dispatch({ type: 'livekit-quality-test', qualityObj });
      })
      .catch((error) => {
        console.log('Error running the LiveKit test', error);
        dispatch({ type: 'livekit-connectivity-test', statusObj });
        dispatch({ type: 'set-livekit-status-error', error });
      });
  }, [dispatch, provider]);

  return { startLivekitTest } as const;
}
